<template lang="html">

 <section class="videos pad-sec">

  <div class="texto container flex wrap justify-start" v-if="intro">
    <div class="col-50">
     <h2 class="title title-36">{{$t('actualidad.videos.titulo')}}</h2>
     <p>{{$t('actualidad.videos.texto')}}</p>
   </div>
 </div>

 <div class="container">
  <div class="block-layout">
    <h2 class="title title-26">{{$t('actualidad.videos.ultimos')}}</h2>
    <div class="flex wrap justify-between">
     <video-el v-for="(e, key) in videos" :data="e" :key="key" @show="sendToShow"></video-el>
   </div>
 </div>
 <a class="btn btn-dark btn-center -yellow-full" href="https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg" target="_blank">{{$t('actualidad.videos.ver_todos')}}</a>
</div>

<video-visualizer :show="show_video" :id="video_to_show" @closeVideo="closeVideo"></video-visualizer>

</section>
</template>

<script lang="js">

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import Video_el from '@/components/parts/video-el';
  import { mapGetters,mapActions } from 'vuex';
  import VideoVisualizer from '@/components/parts/video-visualizer.vue';


  export default  {
    name: 'videos',
    props: ['intro'],
    created() {
      this.setVideos();
    },
    data() {
      return {
        video_to_show : '',
        show_video : false
      }
    },
    methods: { 
      ...mapActions({
        setVideos: 'setVideos'
      }),
      sendToShow : function(value){
        this.video_to_show = value;
        this.show_video = true;
      },
      closeVideo : function (){
        this.show_video = false;
        this.video_to_show = '';
      }
    },
    computed : {
      ...mapGetters({
        videos: 'getVideos',
      }),
    },
    components: {
      'video-el' : Video_el,
      'video-visualizer': VideoVisualizer
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/view-parts/actualidad-parts/videos.vue